import React from 'react';
import './CustomStepper.scss';

const CustomStepper = ({ currentStep, changeCurrentStep, step1Values }) => {
    let steps;
    if (step1Values?.locationFamilyType === 'commercial') {
        steps = ['Information', 'Rates', 'Features'];
    } else if (step1Values?.locationFamilyType === 'multiFamily') {
        steps = ['Information', 'Rates', 'Features', 'Units'];
    }
    return (
        <div className="steps-container">
            {steps?.map((step, index) => {
                return (
                    <React.Fragment key={index}>
                        <div className="step-wrapper">
                            <p
                                className={`step ${index === currentStep && 'active-step'} ${index < currentStep && 'completed-step'}`}
                                onClick={() => {
                                    changeCurrentStep(index);
                                }}
                            >
                                {index + 1}
                            </p>
                            <p className={`step-label ${index === currentStep && 'active-step-label'}`}>{step}</p>
                        </div>
                        <div
                            className={`${index > (step1Values?.locationFamilyType === 'commercial' ? 1 : 2) ? 'd-none' : 'step-connector'}`}
                        ></div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default CustomStepper;
